import { Component } from "react";
import ErrorComponent from "./ErrorComponent";

class ErrorBoundary extends Component {
  state = {
    error: false,
  };

  componentDidCatch(error, info) {
    this.setState({
      error: true,
    });
  }

  componentDidUpdate(prevProps) {
    // 🔹 URL이 변경되면 `error` 상태 초기화
    if (this.props.location !== prevProps.location) {
      this.setState({ error: false });
    }
  }

  render() {
    const { error } = this.state;

    if (error) {
      return <ErrorComponent />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
